import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import type { SiteControllerSettingTemairazuFormModel } from "@/components/features/settings/site-controller/model/temairazu/type";
import type { SiteControllerSettingTemairazuFormModelMethodsType } from "@/components/features/settings/site-controller/model/temairazu/use-case/use-create-model/methods";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	setUpRoomPriceByChillnn: SiteControllerSettingTemairazuFormModel["ViewModel"]["setUpRoomPriceByChillnn"]; //
	onSetSetUpRoomPriceByChillnn: SiteControllerSettingTemairazuFormModelMethodsType["siteControllerSettingNeppanFormModelMethods"]["onSetSetUpRoomPriceByChillnn"];
};

export const SettingsSiteControllerTemairazuSetUpRoomPriceByChillnn = ({
	setUpRoomPriceByChillnn,
	onSetSetUpRoomPriceByChillnn,
}: Props) => {
	return (
		<QuestionForMain
			guide="手間いらずではなく、CHILLNNの管理画面上で部屋の料金を管理するための設定です。ここにチェックを入れると、手間いらずの料金設定は反映されなくなります。"
			required={false}
			title={"CHILLNNで部屋料金を管理しますか？"}
			belowTitleChildren={
				<p className="text-sm text-error-600">
					CHILLNNで作成したプランを手間いらずと料金連携している場合、「CHILLNNで部屋の料金を管理する」に変更すると、
					<br />
					該当プランの料金設定は無効になり自動的に非公開になります。
					<br />
					変更後、あらためて料金を設定し直した上で、公開に戻してください。
				</p>
			}
			inputChildren={
				<CheckboxField
					label="CHILLNNで部屋の料金を管理する"
					value={setUpRoomPriceByChillnn?.value ?? false}
					errorMessage={setUpRoomPriceByChillnn?.error}
					handleChange={onSetSetUpRoomPriceByChillnn}
				/>
			}
		/>
	);
};

SettingsSiteControllerTemairazuSetUpRoomPriceByChillnn.displayName =
	"SettingsSiteControllerTemairazuSetUpRoomPriceByChillnn";
